/*
 * lwc-buybar.js - the sticky add to cart bar in snippets/lwc-buybar.liquid.
 * Phones and tablets; assets/lwc-corrections.css hides it from 1024px up
 * (@media min-width:1024px { .product-buy-bar.lwc-buybar { display:none } }).
 * That rule used to live in assets/lwc-final6.css, which has not been loaded
 * since the twenty lwc-*.css sheets were consolidated on 12 August 2026.
 *
 * Shows the bar only once the real Add to Cart has been scrolled PAST, not
 * merely once it is off screen: on a product page the button starts below the
 * fold, and a bar that is there from the first paint is just a second button
 * competing with the first.
 *
 * Hides it again when the footer reaches the strip of screen the bar occupies,
 * so it never sits on top of the footer links. It used to hide as soon as one
 * pixel of the footer appeared anywhere in the viewport, and the footer on this
 * theme is around 900px tall, so on a 3,500px product page the bar vanished for
 * the last third of the scroll - which includes the reviews, where a shopper is
 * being persuaded. The observer is given the bottom band of the viewport as its
 * root instead, so the answer is "is the footer where the bar is" rather than
 * "is the footer anywhere". The band is measured from the bar itself and is
 * remeasured on resize and orientation change, since rootMargin is fixed at
 * the moment an observer is created.
 *
 * 19 August 2026. ONCE THE PAGE TAIL IS REACHED THE BAR STAYS DOWN.
 * The footer observer set footerInView straight from entry.isIntersecting, and
 * an IntersectionObserver reports "not intersecting" both BEFORE an element
 * arrives and AFTER it has gone by. The footer-group on this theme is two
 * sections, not one: the footer itself and a separate "legal" section under it
 * carrying the packaged liquor licence number. Measured at 390x844 on
 * /products/delord-1992-bas-armagnac-40-700ml (footer 4549-5343, legal
 * 5343-5691, maximum scroll 4847): the bar correctly went down at y=3929 when
 * the footer reached its strip, and then came back up at y=4799 to the bottom
 * of the page, sitting on the licence line, because the footer had left the
 * band upwards and "not intersecting" was being read as "not there yet".
 * The direction is now checked the same way the Add to Cart anchor above
 * already checks it, so anything below the footer - the legal strip today,
 * whatever is added tomorrow - is covered without naming it.
 *
 * If IntersectionObserver is missing the bar is left where it is, off screen,
 * aria-hidden and inert. The main Add to Cart is unaffected either way.
 */
(function () {
  'use strict';

  var bar = document.querySelector('[data-lwc-buybar]');
  if (!bar) return;
  if (!('IntersectionObserver' in window)) return;

  var form = document.getElementById(bar.getAttribute('data-form') || '');

  // Fallback: the snippet is rendered from a custom_liquid block, so if the
  // section id ever fails to reach it, find the real add-to-cart form and
  // point the button at that instead. getAttribute, not .id: a form element
  // exposes its named controls as properties, and this form has an input named
  // "id" for the variant, so form.id is that input, not the string.
  if (!form) {
    form = document.querySelector('product-form form[data-type="add-to-cart-form"]');
    if (!form) return;
    var formId = form.getAttribute('id');
    if (!formId) return;
    var submit = bar.querySelector('button[type="submit"]');
    if (submit) submit.setAttribute('form', formId);
  }

  var anchor = form.querySelector('button[name="add"]');
  if (!anchor) return;

  var footer =
    document.querySelector('[id^="shopify-section"][id*="footer"]') ||
    document.querySelector('footer.footer');

  var scrolledPast = false;
  var footerInView = false;

  function apply() {
    var shouldShow = scrolledPast && !footerInView;
    if (shouldShow === bar.classList.contains('show')) return;

    if (shouldShow) {
      bar.classList.add('show');
      bar.removeAttribute('aria-hidden');
      bar.removeAttribute('inert');
    } else {
      bar.classList.remove('show');
      bar.setAttribute('aria-hidden', 'true');
      bar.setAttribute('inert', '');
    }
  }

  new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
    });
    apply();
  }).observe(anchor);

  if (footer) {
    var footerObserver = null;

    // The band the bar occupies, plus a little, expressed as a root shrunk from
    // the top. Guarded so a viewport shorter than the bar cannot produce a
    // positive margin, which would grow the root instead of shrinking it.
    function band() {
      var h = bar.offsetHeight || 72;
      return Math.max(0, window.innerHeight - h - 8);
    }

    function watchFooter() {
      if (footerObserver) footerObserver.disconnect();
      footerObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            // Intersecting means the footer is in the bar's strip now. A top
            // above the viewport means it is already past, and everything
            // below it is page tail, so the bar stays down to the end of the
            // document. Both are "do not show".
            footerInView =
              entry.isIntersecting || entry.boundingClientRect.top < 0;
          });
          apply();
        },
        { rootMargin: '-' + band() + 'px 0px 0px 0px' }
      );
      footerObserver.observe(footer);
    }

    watchFooter();

    var resizeTimer = null;
    function onResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(watchFooter, 150);
    }
    window.addEventListener('resize', onResize);
    window.addEventListener('orientationchange', onResize);
  }
})();
